import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { Power } from 'react-feather';
import { useNavigate } from 'react-router-dom';

import { Tooltip, Menu, MenuItem, IconButton as MuiIconButton, Button } from '@mui/material';
import { Box } from '@mui/system';

import useAuth from '../../hooks/useAuth';
import { ACCESS_TOKEN_USER } from '../../const';

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
  
  @media (max-width: 600px) {
    padding: 8px;
  }
`;

const AdminButton = styled(Button)`
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
  
  @media (max-width: 600px) {
    font-size: 12px;
    padding: 4px 8px;
  }
`;

const NavbarUserDropdown = () => {
  const [anchorMenu, setAnchorMenu] = React.useState(null);
  const navigate = useNavigate();
  const { signOut, setUserMe, signOutAsUser } = useAuth();
  const isUserView = useMemo(
    () => window.localStorage.getItem(ACCESS_TOKEN_USER),
    [window.localStorage.getItem(ACCESS_TOKEN_USER)],
  );

  const toggleMenu = (event) => {
    setAnchorMenu(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const handleSignOut = async () => {
    await signOut();
    setUserMe(null);
    navigate('/auth/sign-in');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'right',
        color: '#646363',
      }}>
      {isUserView && (
        <AdminButton
          sx={{
            backgroundColor: 'transparent',
            color: '#646363',
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}
          onClick={() => {
            signOutAsUser();
            window.location.href = '/admin/users';
          }}>
          Gå till Admin
        </AdminButton>
      )}
      <Tooltip title="Account">
        <IconButton
          aria-owns={anchorMenu ? 'menu-appbar' : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          color="inherit"
          size="large">
          <Power />
        </IconButton>
      </Tooltip>
      <Menu
        id="menu-appbar"
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            minWidth: '150px',
            mt: 1,
          },
        }}
      >
        <MenuItem
          onClick={handleSignOut}
          sx={{
            fontSize: '14px',
            padding: '12px 16px',
          }}
        >
          Logga ut
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default NavbarUserDropdown;
